export default (theme) => ({
    displayTitle: {
        boxSizing: 'border-box',
        display: 'flex',
        flexWrap: 'wrap',
        WebkitBoxPack: 'justify',
        justifyContent: 'space-between',
        fontSize: '18px',
        fontWeight: 500,
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
    },
    displayBody: {
        paddingTop: '20px',
    },
    facebookButton: {
        color: '#4267B2',
    },
    linkedInButton: {
        color: '#2867B2',
    },
    twitterButton: {
        color: '#1DA1F2',
    },
    instagramButton: {
        color: '#fff',
        background: 'radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%, #d6249f 60%, #285AEB 90%)',
        borderRadius: '27%'
    },
    inactiveButton: {
        opacity: 0.26,
    }
});